module.exports = require("@lattice-automation/react-resize-detector");